import { useQuery } from '@tanstack/react-query';
import { instagramQueries } from '@round/api';

const audioOptions = instagramQueries.audio.options.detail;
const helpers = instagramQueries.audio.utils.detail;

export default function useAudioData(audioId: number) {
    return { query: useQuery(audioOptions(audioId)), helpers };
}
